import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import CourseCardHead from './CourseCardHead';
import MaterialTiles from './MaterialTiles';
import CertificateRow from '../../../Certificates/CertificateRow';

import './course-card.style.scss';

const CourseCard = ({ course }) => {
  const lastLesson = course.last_lesson || null;
  const done = Number(course.event_lesson_count) || 0;
  const total = Number(course.study_lesson_count) || 0;
  const percent = Math.max(0, Math.min(100, Number(course.lesson_persent) || 0));
  const navigate = useNavigate();
  const canOpen = Boolean(course.program_id);

  const openCourse = (event) => {
    if (!canOpen || event.target.closest('button, a, input, [role="button"]')) {
      return;
    }
    localStorage.setItem('programId', JSON.stringify(course.program_id));
    navigate('/course/program');
  };

  return (
    <article className={`course-card ${canOpen ? 'course-card--clickable' : ''}`.trim()} onClick={openCourse}>
      <CourseCardHead
        image={course.image}
        title={course.direction_name}
        programName={course.program_name}
        programId={course.program_id}
      />

      <div className="course-card__progress">
        <span className="course-card__progress-label">Прогрес курсу</span>
        <span className="course-card__progress-value">
          {done} із {total} уроків <b>· {percent}%</b>
        </span>
        <span className="course-card__bar"><i style={{ width: `${percent}%` }}></i></span>
      </div>

      {lastLesson && (
        <div className="course-card__materials">
          <h4 className="course-card__subtitle">Матеріали з останнього заняття</h4>
          <MaterialTiles lesson={lastLesson} />
        </div>
      )}

      <CertificateRow
        programId={course.program_id}
        programTitle={course.direction_name}
        progress={percent}
        lessonsLeft={Math.max(0, total - done)}
        lesson={lastLesson}
      />
    </article>
  );
};

CourseCard.propTypes = {
  course: PropTypes.object.isRequired,
};

export default CourseCard;
